import React from 'react'
import { Button } from '../Button/Button'
import { Modal } from './Modal'
import styles from './modal.module.scss'

export type ConfirmDialogProps = {
  /** Controlled: whether the dialog is visible */
  open: boolean
  title: string
  message: string
  /** Visual variant for the confirm button */
  variant?: 'default' | 'danger'
  /** Label for the confirm button (default: 'Confirmar') */
  confirmLabel?: string
  /** Label for the cancel button (default: 'Cancelar') */
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
}

/**
 * Confirmation dialog for destructive or irreversible actions.
 * Builds on Modal for focus management and Esc support.
 * Presentational only — no tRPC / domain types.
 */
export const ConfirmDialog = ({
  open,
  title,
  message,
  variant = 'default',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmDialogProps): React.ReactElement => {
  return (
    <Modal open={open} title={title} onClose={onCancel} maxWidth="44rem">
      <p className={`m-b-24 txt-kale ${styles['confirm-dialog__message']}`}>{message}</p>
      <div className="row-flx flx-j-e flx-gap-12">
        <Button
          variant="pill"
          type="button"
          bgColor="cream"
          txtColor="kale"
          onClick={onCancel}
          disabled={isLoading}
          label={cancelLabel}
        />
        <Button
          variant="pill"
          type="button"
          bgColor={variant === 'danger' ? 'grana' : 'olive'}
          txtColor="white"
          onClick={onConfirm}
          disabled={isLoading}
          label={confirmLabel}
        />
      </div>
    </Modal>
  )
}
